import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Table } from 'hljd'
import columns from './columns'
import store from '../store'
import { toJS } from 'mobx'

@observer
export default class extends Component {
  render() {
    return (
      <Table
        rowKey={record => record.id}
        columns={columns}
        bordered={false}
        locale={{ emptyText: '暂无公告' }}
        pagination={false}
        dataSource={toJS(store.list)}
      />
    )
  }
}
